import apiClient from "../utils/Http";

export const cartGet = () => apiClient.get("api/store/cart/");

export const cartAdd = (productId, quantity = 1) =>
  apiClient.post("api/store/cart/add/", { product: productId, quantity });

export const cartUpdateItem = (itemId, quantity) =>
  apiClient.patch(`api/store/cart/item/${itemId}/`, { quantity });

export const cartRemoveItem = (itemId) =>
  apiClient.delete(`api/store/cart/item/${itemId}/delete/`);

export const cartClear = () => apiClient.delete("api/store/cart/clear/");